export const env = {
  BASE_URL_API: `${process.env.REACT_APP_BASE_URL_API}/api`,
  BASE_URL_API_PAY: `${process.env.REACT_APP_BASE_URL_API_PAY}/api`,
  BASE_URL_API_INVENTORIES: `${process.env.REACT_APP_BASE_URL_API_INVENTORIES}/api`,
  TRINO_BASE_URL: process.env.REACT_APP_TRINO_BASE_URL ?? 'https://trino.parrot.rest',
  TRINO_HOSTS: (process.env.REACT_APP_TRINO_HOSTS ?? '')
    .split(',')
    .map((host) => host.trim())
    .filter(Boolean),
  GROW_BASE_URL: process.env.REACT_APP_GROW_BASE_URL ?? 'https://grow.parrot.rest',
  GROW_LANDING_URL: process.env.REACT_APP_GROW_LANDING_URL ?? 'https://parrotsoftware.com.mx/soluciones/parrot-grow',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
};
